
import React from 'react';
import FeatureErrorBoundary from '@/components/FeatureErrorBoundary';
import { type EnhancedCrawlResult } from '@/types/crawler';
import FaqExpertWidgetContent from '@/components/faq-expert/FaqExpertWidget';

interface FaqExpertWidgetProps {
  crawlResult: EnhancedCrawlResult;
  widgetRef: React.RefObject<HTMLDivElement>;
  onRetry: () => void;
}

const FaqExpertWidget: React.FC<FaqExpertWidgetProps> = ({
  crawlResult,
  widgetRef,
  onRetry
}) => {
  return (
    <div ref={widgetRef} className="pt-8" id="faq-serp" data-testid="widget-faq-serp">
      <FeatureErrorBoundary 
        componentName="FAQ Expert Widget" 
        onRetry={onRetry}
      >
        <FaqExpertWidgetContent result={crawlResult} onRetry={onRetry} />
      </FeatureErrorBoundary>
    </div>
  );
};

export default FaqExpertWidget;
